import type { ListItemProps } from "@/components/ListItem/ListItem";
import MultiSectionDetailsCard from "@/components/MultiSectionDetailsCard";
import ManagingSectionLocationCard from "@/pages/activities/_components/ManagingSectionLocationCard";
import SectionHeading from "@/components/SectionHeading";
import { toUTCFormat } from "@/lib/dateHelpers";
import { ActivityOutletContext } from "./_layout";
import { useOutletContext } from "react-router-dom";
import { renderContent } from "@/lib/htmlContentHelpers";
import { lowerCase } from "lodash";
import pluralize from "@/lib/pluralize";
import SelfCheckInSection from "./_components/SelfCheckInSection";

export default function ActivityInstanceOverview() {
  const { activityData } = useOutletContext<ActivityOutletContext>();

  if (!activityData) {
    return <div className="text-title-large">Activity not found</div>;
  }
  const getDuration = () => {
    return activityData.duration
      ? `${activityData.duration} ${pluralize(
          activityData.duration,
          lowerCase(activityData.activityType.config.creditRates[0].rateUnit),
          "s"
        )}`
      : "--";
  };

  const activityDetailsSection: ListItemProps[] = [
    {
      iconName: "schedule" as const,
      iconBackground: true,
      overline: "Duration",
      headline: getDuration()
    },
    {
      iconName: "update" as const,
      iconBackground: true,
      overline: "Modified",
      headline: toUTCFormat(activityData.updatedAt)
    },
    {
      iconName: "calendar_today" as const,
      iconBackground: true,
      overline: "Created",
      headline: toUTCFormat(activityData.createdAt)
    }
  ];

  return (
    <div className="flex flex-col">
      <div className="grid grid-cols-1 md:grid-cols-12 sm:gap-12">
        <div className="col-span-1 md:col-span-4 mt-12 flex flex-col gap-6">
          <MultiSectionDetailsCard
            sections={[
              {
                heading: "Activity Details",
                options: activityDetailsSection
              }
            ]}
          />
          <ManagingSectionLocationCard sectionName={activityData.managingSection.name} />
        </div>
        <div className="col-span-1 md:col-span-8 sm:mt-7">
          <div className="border-0 border-sys-brand-secondary-container pb-12">
            <SectionHeading heading="Description" />
            <div className="text-body-large word-break text-sys-brand-on-surface">
              {renderContent(activityData.internalDescription || "No description provided", { enhancedCleanup: false })}
            </div>
          </div>
          {activityData.checkinEnabled && (
            <SelfCheckInSection activityId={activityData.id} activityTitle={activityData.title} />
          )}
        </div>
      </div>
    </div>
  );
}
